import React from "react"

import StyledLink from "./style"

function BackToDashLink() {
  return <StyledLink to="/">← Explore More</StyledLink>
}

export default BackToDashLink
